import React, { useState } from 'react';
import { Button, Card, Space, Typography, message } from 'antd';
import { MailOutlined, SafetyCertificateOutlined, UserOutlined } from '@ant-design/icons';
import axios from 'axios';
import API_ROUTES from '../api';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;

export default function AuditPendingNotice({
    title = 'Your account requires manual review.',
    description = 'Your account is currently under manual review. You will receive an email notification once the review is complete. The review usually takes 1–2 working days.',
    buttonText = 'Request review reminder',
}) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [reminded, setReminded] = useState(localStorage.getItem('auditReminded') === '1');
    const [messageApi, contextHolder] = message.useMessage();

    // 待审核账号点击后通知所有管理员进行人工审核
    const remindAdmins = () => {
        setLoading(true);
        axios.post(API_ROUTES.api_audit_remind, null, {
            headers: {
                Authorization: localStorage.getItem('userInfo'),
            },
        }).then((response) => {
            if (response.data.code === 200) {
                localStorage.setItem('auditReminded', '1');
                setReminded(true);
                messageApi.success('Audit reminder has been sent to the administrators.');
            } else {
                if (String(response.data.msg || '').includes('already')) {
                    localStorage.setItem('auditReminded', '1');
                    setReminded(true);
                }
                messageApi.error(response.data.msg || 'Failed to send audit reminder.');
            }
        }).catch(() => {
            messageApi.error('Failed to send audit reminder.');
        }).finally(() => {
            setLoading(false);
        });
    };

    return (
        <div style={{
            minHeight: 'calc(100vh - 220px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '48px 20px',
            background: '#f4f8fa'
        }}>
            {contextHolder}
            <Card
                bordered={false}
                style={{
                    width: '100%',
                    maxWidth: 560,
                    borderRadius: 20,
                    textAlign: 'center',
                    boxShadow: '0 18px 42px rgba(7, 58, 82, 0.10)'
                }}
                bodyStyle={{ padding: '44px 42px' }}
            >
                <div style={{
                    width: 68,
                    height: 68,
                    margin: '0 auto 20px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#0b6f82',
                    background: '#e7f6f8',
                    fontSize: 30
                }}>
                    <SafetyCertificateOutlined />
                </div>
                <Title level={3} style={{ color: '#123243', marginBottom: 12 }}>
                    {title}
                </Title>
                <Paragraph style={{ color: '#4b6472', fontSize: 16, lineHeight: 1.7, marginBottom: 28 }}>
                    {description}
                </Paragraph>
                <Space direction="vertical" size={12}>
                    <Button
                        type="primary"
                        size="large"
                        icon={<MailOutlined />}
                        loading={loading}
                        disabled={reminded}
                        onClick={remindAdmins}
                        style={{
                            height: 46,
                            borderRadius: 999,
                            padding: '0 28px',
                            background: reminded ? '#9ab7bf' : '#0b6f82',
                            borderColor: reminded ? '#9ab7bf' : '#0b6f82',
                            fontWeight: 700
                        }}
                    >
                        {reminded ? 'Review reminder already sent' : buttonText}
                    </Button>
                    <Button
                        size="large"
                        icon={<UserOutlined />}
                        onClick={() => navigate('/profile')}
                        style={{ height: 44, borderRadius: 999, padding: '0 26px', fontWeight: 700 }}
                    >
                        View profile under review
                    </Button>
                </Space>
            </Card>
        </div>
    );
}
